// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"239":"ticket","251":"checkout","362":"redemption-group","550":"otp","781":"my-tickets","933":"auth","949":"cart"}[chunkId] || chunkId) + "-legacy.js";
};